var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-headful',{attrs:{"title":_vm.getPageTitle("Accepting Invitation")}}),(_vm.isLoading)?_c('b-loading',{attrs:{"is-full-page":"","active":""}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }